import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "bv-no-focus-ring",
  tabindex: "-1",
  role: "group"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "form__label text-muted comments__public-username" }, "It's your first time posting! Set your public username.", -1)

import { onBeforeMount, ref } from 'vue'

import FormError from '@/components/ui/FormError.vue'
import InputWithContextMenu from '@/app/components/InputWithContextMenu.vue'
import { auth } from '@/services/auth'
import { ValidationState } from '@/helpers/form'


export default /*#__PURE__*/_defineComponent({
  __name: 'UsernameInput',
  props: {
    model: null,
    validation: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  model: any
  validation: ValidationState
};



const hasUsername = ref(true)

onBeforeMount(() => {
  /* eslint-disable vue/no-mutating-props */
  props.model.username = auth.getUsername()
  /* eslint-enable vue/no-mutating-props */
  if (!props.model.username) {
    hasUsername.value = false
  }
})

function saved(): void {
  const username = auth.getUsername()
  if (username) {
    hasUsername.value = true
  }
}

expose({
  saved,
})

return (_ctx: any,_cache: any) => {
  return (!hasUsername.value)
    ? (_openBlock(), _createElementBlock("fieldset", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(InputWithContextMenu, {
            modelValue: __props.model.username,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.model.username) = $event)),
            class: _normalizeClass(["form-control", __props.validation.stateClass('username')]),
            placeholder: "Enter username here",
            type: "text"
          }, null, 8, ["modelValue", "class"]),
          _createVNode(FormError, {
            errors: __props.validation.errors,
            field: "username"
          }, null, 8, ["errors"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})